import { useState } from 'react';
import { Validation } from '@/models';
import useValidation from './useValidation';

const emptyPredicat = (value: string) => value === '';
const notEmptyPredicat = (value: string) => value !== '';

function useInputBool(initialValue: boolean, validations: Validation[]) {
  const [value, setValue] = useState<boolean>(initialValue);
  const [isDirty, setIsDirty] = useState(false);

  const validationErrors = useValidation(value, validations);

  const onChange = (newValue: boolean) => {
    setValue(newValue);
  };

  const onBlur = () => {
    setIsDirty(true);
  };

  const onReset = () => {
    setIsDirty(false);
    setValue(false);
  };

  const errorMessages = Object.values(validationErrors);

  return {
    value,
    isDirty,
    onChange,
    onBlur,
    onReset,
    isValid: errorMessages.every(emptyPredicat),
    errors: errorMessages.filter(notEmptyPredicat),
  };
}

export default useInputBool;
